import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface SessionState {
    sessionDetails: SessionDetails
}

export interface SessionDetails {
    FirstName: string;
    LastName: string;
    MiddleName: string;
    PhoneNumber: string;
    RouteId:  string;
    RouteName: string;
    isActive: boolean;
    Email: string;
    createOn: string;
    UploadPictureUrl: string;
    Occupation: string;
    transactionStatus?: string;
    SelectedCategory?:string
    CorprateName?: string;
    HasPaidApplicationFee:boolean;
    IsSubmitted:boolean;
    HasPaidAcceptanceFee:boolean;
    PaymentStatus:string;
    ActionName:string;
    ActionId:number;
    HasPaidTrainingFee:boolean;
    HasPaidInductionFee : boolean;
    Amount: number;
    MembershipNo: string;
    
}


const initialState: SessionState = {
  sessionDetails : {
    FirstName:"",
    LastName: "",
    MiddleName: "",
    PhoneNumber: '',
    RouteId: '',
    RouteName: "",
    isActive: false,
    Email: "",
    createOn: "",
    UploadPictureUrl: "",
    Occupation:'',
    transactionStatus: '',
    SelectedCategory:'',
    CorprateName: '',
    HasPaidApplicationFee:false,
    IsSubmitted:false,
    HasPaidAcceptanceFee:false,
    PaymentStatus:"",
    ActionName:"",
    ActionId:0,
    HasPaidTrainingFee:false,
    HasPaidInductionFee: false,
    Amount: 0,
    MembershipNo: ""
  } 
} 



export const sessionSlice  = createSlice({
    name: 'sessionDetails',
    initialState,
    reducers: {
        updateSession: (state, action: PayloadAction<SessionDetails>) => {
            state.sessionDetails = action.payload;
        }
    }
});
 
export const {updateSession} = sessionSlice.actions;

export default sessionSlice.reducer;